import { render, staticRenderFns } from "./OrderCompanyDetailSection.vue?vue&type=template&id=1fe06993&"
import script from "./OrderCompanyDetailSection.vue?vue&type=script&lang=ts&"
export * from "./OrderCompanyDetailSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports